export default __webpack_public_path__ + "static/media/medium.bd46e6b9.svg";